export default "__VITE_ASSET__BHNxlu8Y__"